export default {"src":"/_next/static/media/briefcase_40.a942b276.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};